import { render, staticRenderFns } from "./guardian_invite_row.vue?vue&type=template&id=9985f330&"
import script from "./guardian_invite_row.vue?vue&type=script&lang=js&"
export * from "./guardian_invite_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports